import { render, staticRenderFns } from "./MyCheckbox.vue?vue&type=template&id=73f60e8d&"
import script from "./MyCheckbox.vue?vue&type=script&lang=js&"
export * from "./MyCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MyCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports